module.exports = __webpack_public_path__ + "8e76c812394b849b4ecc332326ec0742.MP3";